export default __webpack_public_path__ + "static/media/ci_chevron-big-right.18c93c74.svg";